import { Navigate, Outlet } from 'react-router-dom'

function isAuthenticated(): boolean {
  return localStorage.getItem('amz_ads_token') !== null
}

export default function ProtectedRoute() {
  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />
  }
  return <Outlet />
}
